module.exports = __webpack_public_path__ + "/bundle/asset/revision2-b5ad17f904176517577d10e096a6b05f.png";